<div class="component text-center ps-2 pe-2" [style.backgroundColor]="backgroundColor" [style.color]="color"
     [class.p-2]="!compact" [class.compact]="compact">
    <ng-content></ng-content>&nbsp;
</div>
